var chunkMapping = {
	"982": [
		7320,
		8339,
		8495,
		16168,
		17353,
		18720,
		19909,
		21632,
		22394,
		22816,
		29211,
		30242,
		32210,
		35790,
		38863,
		39437,
		42512,
		42704,
		43069,
		51496,
		53677,
		56044,
		64332,
		69455,
		81095,
		93591,
		97776
	]
};
var idToExternalAndNameMapping = {
	"7320": [
		"default",
		"./Tooltip",
		2587
	],
	"8339": [
		"default",
		"./Divider",
		2587
	],
	"8495": [
		"default",
		"./WidgetSettings",
		66772
	],
	"16168": [
		"default",
		"./TimezoneSettingsOptionGroup",
		66772
	],
	"17353": [
		"default",
		"./WidgetFilter",
		66772
	],
	"18720": [
		"default",
		"./hooks",
		66772
	],
	"19909": [
		"default",
		"./WidgetContent",
		66772
	],
	"21632": [
		"default",
		"./PanelItem",
		66772
	],
	"22394": [
		"default",
		"./widgetContext",
		66772
	],
	"22816": [
		"default",
		"./PanelHeader",
		66772
	],
	"29211": [
		"default",
		"./EmptyStateData",
		2587
	],
	"30242": [
		"default",
		"./List",
		2587
	],
	"32210": [
		"default",
		"./WidgetBody",
		66772
	],
	"35790": [
		"default",
		"./WidgetHeader",
		66772
	],
	"38863": [
		"default",
		"./WidgetCard",
		66772
	],
	"39437": [
		"default",
		"./hooks",
		14403
	],
	"42512": [
		"default",
		"./Tag",
		2587
	],
	"42704": [
		"default",
		"./Icon",
		2587
	],
	"43069": [
		"default",
		"./Avatar",
		2587
	],
	"51496": [
		"default",
		"./ListItem",
		2587
	],
	"53677": [
		"default",
		"./Selectors",
		14403
	],
	"56044": [
		"default",
		"./WidgetTitle",
		66772
	],
	"64332": [
		"default",
		"./Spin",
		2587
	],
	"69455": [
		"default",
		"./ProductPanel",
		66772
	],
	"81095": [
		"default",
		"./Space",
		2587
	],
	"93591": [
		"default",
		"./workspaceContext",
		66772
	],
	"97776": [
		"default",
		"./Text",
		2587
	]
};
__webpack_require__.f.remotes = (chunkId, promises) => {
	if(__webpack_require__.o(chunkMapping, chunkId)) {
		chunkMapping[chunkId].forEach((id) => {
			var getScope = __webpack_require__.R;
			if(!getScope) getScope = [];
			var data = idToExternalAndNameMapping[id];
			if(getScope.indexOf(data) >= 0) return;
			getScope.push(data);
			if(data.p) return promises.push(data.p);
			var onError = (error) => {
				if(!error) error = new Error("Container missing");
				if(typeof error.message === "string")
					error.message += '\nwhile loading "' + data[1] + '" from ' + data[2];
				__webpack_require__.m[id] = () => {
					throw error;
				}
				data.p = 0;
			};
			var handleFunction = (fn, arg1, arg2, d, next, first) => {
				try {
					var promise = fn(arg1, arg2);
					if(promise && promise.then) {
						var p = promise.then((result) => (next(result, d)), onError);
						if(first) promises.push(data.p = p); else return p;
					} else {
						return next(promise, d, first);
					}
				} catch(error) {
					onError(error);
				}
			}
			var onExternal = (external, _, first) => (external ? handleFunction(__webpack_require__.I, data[0], 0, external, onInitialized, first) : onError());
			var onInitialized = (_, external, first) => (handleFunction(external.get, data[1], getScope, 0, onFactory, first));
			var onFactory = (factory) => {
				data.p = 1;
				__webpack_require__.m[id] = (module) => {
					module.exports = factory();
				}
			};
			handleFunction(__webpack_require__, data[2], 0, 0, onExternal, 1);
		});
	}
}